import Intersection from './Intersection';

export default Intersection;